module.exports = __webpack_public_path__ + "pc/img/body_basic 11.b7e78ea3.jpg";